import { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall, ValidationError } from "../api/api";
import type { Company } from "../api/dto";
import { Autocomplete } from "../components/form/Autocomplete";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const GrantUserAccessModal: FC<{ company: Company }> = (props) => {
  const { users } = useApi();
  const { grantCompanyAccessToUser } = useApiCall();
  const refresh = useRefresh();
  const [company, setCompany] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);
  const userMap = users.filter((c) => c.enabled).map((c) => [c.id, `${c.first_name} ${c.last_name}`]);
  const selectedUser = users.find((c) => c.id === company);

  const save = async () => {
    if (!selectedUser?.id) {
      return;
    }
    await grantCompanyAccessToUser(selectedUser.id, props.company.id, {
      canExecuteAssessments: false,
      canExportAssessments: false,
      canAccessAllAssessments: false,
      canAccessAssessmentHistory: false,
      canManageCompanies: false,
      canManageCompaniesDestructive: false,
      canManageProjects: false,
      canManageProjectsDestructive: false,
      canManageAssessments: false,
      canManageAssessmentsDestructive: false,
      canAccessCertificates: false,
      canAccessDashboards: false,
      canAccessWeb: false,
      canAccessMobile: false,
      canImport: false,
      canManageUsers: false,
      canManageChecklists: false,
      accessibleQuestionSetTypes: [],
    }).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };
  return (
    <div className={""}>
      <div className={"min-h-71 flex-col space-y-3"}>
        <Autocomplete
          label={"Gebruiker"}
          value={company}
          options={Object.fromEntries(userMap)}
          onChange={(c) => {
            setCompany(c);
          }}
        />
      </div>
      <ModalFooter text={"Opslaan"} disabled={!selectedUser?.id} onSubmit={save} />
    </div>
  );
};
